export class FizickiObjekt {
  constructor() {
    //
  }

  'en~fizicki_objekt~id' = '';
  'en~fizicki_objekt~status' = '';
}

type IFizickiObjekt = FizickiObjekt;

export function isFizickiObjekt(item: FizickiObjekt): item is IFizickiObjekt {
  return Object.keys(new FizickiObjekt()).every(
    (key) => Object.keys(item).indexOf(key) > 0
  );
}
